import { t } from '../../common/components/T';
import { API_SERVER_URL } from '../../common/utils/utils';
import uikit from '../../project/uikit/styles';

export const transformThemesData = (data) => {
    return data?.map((theme) => ({
        ...theme,
        title: theme?.name
    }));
};

export const getProfitFilds = (formDataMain, userData, translation) => {
    console.log('formDataMain', formDataMain);
    return [
        {
            attribute: 'guest_name',
            name: 'name',
            title: {
                body: t('getProfitFields-name-title-v1', 'Ваше имя', '/contact', translation)
            },
            placeholder: t('getProfitFields-name-placeholder', 'Введите ваше имя', '/contact', translation),
            hint: false,
            type: 'input',
            disabled: userData,
            value: userData
                ? userData?.first_name || userData?.last_name
                    ? [userData?.first_name, userData?.last_name]?.filter((el) => el)?.join(' ')
                    : userData?.username
                : formDataMain?.guest_name
        },
        {
            sorting: ['email', 'telegram', 'whatsapp', 'input'],
            attribute: 'contact',
            name: 'contact_type',
            title: {
                body: t('getProfitFields-contact_type-title', 'Выберите удобный способ для связи', '/contact', translation)
            },
            hint: false,
            type: 'toggle-input',
            defaultValue: formDataMain?.contact_type || 'email',
            value: formDataMain?.contact,
            buttonsAttribute: 'contact_type',
            options: [
                {
                    id: 'email',
                    icon: 'email-colored',
                    placeholder: t('getProfitFilds-contact-email-placeholder', 'Укажите e-mail', '/contact', translation)
                },
                {
                    id: 'telegram',
                    icon: 'telegram-colored',
                    placeholder: t('getProfitFilds-contact-telegram-placeholder', 'Логин', '/contact', translation),
                    isSocial: true
                },
                {
                    id: 'whatsapp',
                    icon: 'whatsapp-colored',
                    placeholder: 'xxx-xx-xx',
                    type: 'phone-widget'
                }
            ]
        },
        {
            attribute: 'feedback_query_theme_id',
            name: 'name',
            title: {
                body: t('getProfitFields-theme', 'Тема', '/contact', translation)
            },
            placeholder: t('getProfitFilds-theme-placeholder', 'Выберите тему сообщения', '/contact', translation),
            hint: false,
            type: 'dropdown',
            isSearchable: false,
            // options: transformThemesData(themeOptions?.data) || [],
            value: formDataMain?.feedback_query_theme_id || null,
            getOptions: {
                url: `${API_SERVER_URL}/api/v1/feedback/query-themes`
            }
        },
        {
            attribute: 'body',
            name: 'message',
            title: {
                body: t('getProfitFields-body', 'Мое сообщение', '/contact', translation)
            },
            placeholder: t('getProfitFields-body-placeholder', 'Укажите текст Вашего сообщения', '/contact', translation),
            hint: false,
            type: 'textarea',
            value: formDataMain?.body || '',
            hideLengthInfo: true
        }
    ];
};

export const getFilterFilds = (filterParam, transactionsRadio, translation) => {
    return [
        {
            attribute: 'toggle_type',
            required: false,
            disabled: false,
            name: 'toggle_type',
            placeholder: '',
            type: 'radio-switcher',
            options: [
                t('getFilterFields-toggle-map', 'Карта', '/contact', translation),
                t('getFilterFields-toggle-list', 'Список', '/contact', translation)
            ],
            value: transactionsRadio
        },
        {
            attribute: 'info_field',
            title: {
                body: t('getFilterFields-geo-info', 'Укажите местоположение', '/contact', translation)
            },
            type: 'info-field',
            disabled: false
        },
        {
            attribute: 'country_id',
            name: 'country_id',
            require: true,
            // title: { body: '' },
            placeholder: t('getFilterFields-country-placeholder', 'Страна', '/contact', translation),
            hint: false,
            type: 'location_widget',
            options: [],
            value: filterParam?.country_id && {
                value: filterParam?.country_id?.value,
                label: filterParam?.country_id?.label
            }
        },
        {
            attribute: 'region_id',
            name: 'region_id',
            require: true,
            // title: { body: '' },
            placeholder: t('getFilterFields-region-placeholder', 'Область', '/contact', translation),
            hint: false,
            type: 'location_widget',
            options: [],
            value: filterParam?.region_id && {
                value: filterParam?.region_id?.value,
                label: filterParam?.region_id?.label
            }
        },
        {
            attribute: 'type',
            required: false,
            disabled: false,
            name: 'type',
            hint: false,
            title: {
                body: t('getFilterFields-type-title', 'Укажите центр обслуживания', '/contact', translation),
                links: false
            },
            type: 'checkbox-list',
            options: [
                {
                    id: 'agency',
                    title: t('getProfitFields-agency', 'Представительство', '/contact', translation)
                },
                {
                    id: 'central',
                    title: t('getProfitFields-office', 'Центральный офис', '/contact', translation)
                },
                {
                    id: 'store',
                    title: t('getProfitFields-store', 'Склад', '/contact', translation)
                }
            ],
            value: [
                { id: 'agency', value: false },
                { id: 'central', value: false },
                { id: 'store', value: false }
            ]
        }
    ];
};

export const getFormStyles = (css) => ({
    toggle_type: {
        content: {
            ...uikit.justifyContentCenter,
            ...uikit.pt3,
            ...uikit.pb3
        }
    },
    info_field: {},
    guest_name: { input: { className: css.guestNameInput } },
    contact: { wrapper: { className: css.contactWrapper } },
    feedback_query_theme_id: {},
    body: { wrapper: { className: css.bodyWrapper } },
    country_id: {},
    region_id: {},
    type: {}
});
